module.exports = __webpack_public_path__ + "src/assets/img/car.982d1de6.svg";